import { Editable, EditablePreview, EditableInput, HStack, useEditableControls } from '@chakra-ui/react';
import { UilEditAlt } from '@iconscout/react-unicons';

function setProjectName({ name, projectInfo, setProjectInfo }) {
	const newProjectInfo = { ...projectInfo };
	newProjectInfo.viewName = name;
	setProjectInfo(newProjectInfo);
}

const CreateSaveProjectName = ({ projectInfo, setProjectInfo }) => {
	function EditableControls() {
		const { isEditing, getEditButtonProps } = useEditableControls();
		return !isEditing ? <UilEditAlt size={'16'} {...getEditButtonProps()} /> : null;
	}

	return (
		<Editable
			_hover={{ cursor: 'pointer' }}
			onSubmit={(name) => setProjectName({ name, projectInfo, setProjectInfo })}
			defaultValue={projectInfo.viewName ? projectInfo.viewName : 'Nome do Projeto'}
		>
			<HStack alignItems={'center'}>
				<EditablePreview _hover={{ cursor: 'pointer' }} />
				<EditableInput ml={'0 !important'} />
				<EditableControls />
			</HStack>
		</Editable>
	);
};

export default CreateSaveProjectName;
